var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',[_vm._v("version: "+_vm._s(_vm.version))]),_c('div',[_vm._v("commit: "+_vm._s(_vm.commit))])])
}
var staticRenderFns = []

export { render, staticRenderFns }